/**
 * Sur web.app-secura.com, seules les pages Projets / Tâches existent :
 * toute autre adresse (tableau de bord, congés, paie…) ramène à la liste des projets.
 */
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { isAllowedOnWebHost, isWebHost } from '../../utils/webHost';

export default function WebHostGuard() {
  const location = useLocation();
  if (!isWebHost() || isAllowedOnWebHost(location.pathname)) return null;
  return <Navigate to={location.pathname === '/' ? '/login' : '/projets'} replace />;
}
